

















































import { Component, Mixins } from 'vue-property-decorator'

import AppHeader from '@/components/app/AppHeader.vue'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import DeviceBuilder from '@/views/sandbox/builder/device/DeviceBuilder.vue'
import BuilderDeviceProfileStub from '@/components/builder/BuilderDeviceProfileStub.vue'
import { mapGetters, mapState } from 'vuex'
import { App } from '@/services/types'
import WithBuilderStubProperties from '@/mixins/WithBuilderStubProperties'
import BuilderButton from '@/components/builder/BuilderButton.vue'

@Component({
  components: {
    AppHeader,
    BuilderButton,
    BuilderDeviceProfileStub,
    DeviceBuilder,
    BuilderDefaultContainer
    
  },
  computed: {
    ...mapGetters('builder', { app: 'getApp' }),
    ...mapState('app', {showMenu: 'showMenu'})
  },
  created() {
    this.$store.dispatch('app/changeVisibilityMenu', true)
  }
})
export default class BuilderProfileCreated extends Mixins(WithBuilderStubProperties) {
  app!: App | null
  viewMode = false
  async onNextClick(): Promise<void> {
    await this.$router.push({
      name: 'chat.public',
      params: this.app ? { id: String(this.app.id) } : {},
    })
  }
}
